import { render, staticRenderFns } from "./PayDivideTemplate.vue?vue&type=template&id=57de5d6e&scoped=true&"
import script from "./PayDivideTemplate.vue?vue&type=script&lang=js&"
export * from "./PayDivideTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PayDivideTemplate.vue?vue&type=style&index=0&id=57de5d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de5d6e",
  null
  
)

export default component.exports